/**
 * MyDataLinkCard — връзка към единния център „Моите данни" в профила.
 * Ползва се от модулите, за да няма дублиране на едни и същи карти.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { Database, ArrowRight } from "lucide-react";
import { useTheme } from "@/theme/ThemeContext";

export const MyDataLinkCard = ({ title, note, testid = "my-data-link-card", cta }) => {
  const navigate = useNavigate();
  const { isDark } = useTheme();
  const card = isDark ? "bg-slate-900/60 border-slate-800" : "bg-white border-slate-200";

  return (
    <button onClick={() => navigate("/dashboard/profile?tab=mydata")}
      className={`w-full p-4 rounded-2xl border text-left hover:shadow-md transition-shadow ${card}`}
      data-testid={testid}>
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-500 to-violet-600
                        flex items-center justify-center shrink-0">
          <Database className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold">{title}</div>
          <div className={`text-[11px] mt-0.5 ${isDark ? "text-slate-400" : "text-slate-600"}`}>
            {note}
          </div>
          <div className="text-[11px] mt-1 font-semibold text-cyan-500">
            {cta || "Отвори раздела Моите данни в профила"}
          </div>
        </div>
        <ArrowRight className="w-4 h-4 text-cyan-500 shrink-0" />
      </div>
    </button>
  );
};

export default MyDataLinkCard;
